import React, { Component } from 'react';

import 'devextreme/dist/css/dx.common.css';
import Switch from "react-switch";
//import Logo from '../../Logo/Logo-Taskview';
import Logo from '../../Logo/logoHeader';
import '../Toolbar/Header.css';
import FetchData from '../../Utils/FetchData';
import { connect } from 'react-redux';
import DataGrid, { Column, Scrolling, Pager, Paging, SearchPanel, ColumnFixing, Button } from 'devextreme-react/data-grid';
import ChangeRole from '../SideDraw/Role/Role';
import setTaskNameAction from '../../../actions/setTaskNameAction';
import setTaskIdAction from '../../../actions/setTaskIdAction';
import setStateAction from '../../../actions/setStateAction';
import setCurrentObjectId from '../../../actions/setCurrentObjectId';
import setCurrentThemeAction from '../../../actions/setCurrentThemeAction';
import setCurrentFooterAction from '../../../actions/setActionFooter';
import setActionTaskContextExpColaps from '../../../actions/setActionTaskContextExpColaps'
import setActionTabs from '../../../actions/setActionTabs'
import SvgLogout from '../../../iconComponents/logoutIcon';
import SvgNotifications from '../../../iconComponents/notificationsIcon';
import SvgLeftarrow from '../../../iconComponents/taskLeftarrow';
import SvgRightarrow from '../../../iconComponents/taskRightarrow';
import SvgSettings from '../../../iconComponents/settingsIcon';
import SvgEllipse from '../../../iconComponents/iconEllipse';
import * as myIcon from "../../../images/icons/Goto.svg";

var headerStyles = window.darkTheme
var arraylocalstorage = [];
var apiVersion;

class HeaderNavbar extends Component {

    constructor(props) {
        super(props);
        this.handleClicksettings = this.handleClicksettings.bind(this);
        this.handleOutsideClicksettings = this.handleOutsideClicksettings.bind(this);
        this.state = {
            checked: true,
            checkedDarkmode: false,
            notificationMessage: 'Show',
            openReady: 'false',
            showColumnLines: false,
            showRowLines: true,
            showBorders: true,
            rowAlternationEnabled: true,
            popupVisible: false
        };
        localStorage.setItem('Caching', true);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeDarkmode = this.handleChangeDarkmode.bind(this);
        this.onValueChanged = this.onValueChanged.bind(this);
        this.gotoObject = this.gotoObject.bind(this);

    }


    handleChange(checked) {
        this.setState({ checked });
        localStorage.setItem('Caching', checked);
        this.props.setUseCache(checked)
    }
    handleChangeDarkmode(checkedDarkmode) {
        this.setState({ checkedDarkmode });
        this.props.currThemeSet(checkedDarkmode) 
    }

    //TM(Thanasis Mourselas): It is called whenever change the state of the parent component TaskView or the state of component it self
    //TM(Thanasis Mourselas): render() will not be invoked if shouldComponentUpdate() returns false.
    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.popupVisible != nextState.popupVisible) {
            return true;
        }
        if (this.props.taskcontextExpandCollapse != nextProps.taskcontextExpandCollapse) {
            return true;
        }
        if (this.props.notificationsCount != nextProps.notificationsCount) {
            return true;
        }
        if (this.props.notifications != nextProps.notifications) {
            return true;
        }
        if (this.state.notificationMessage != nextState.notificationMessage) {
            return true;
        }
        if (this.state.checked != nextState.checked) {
            return true;
        }
        if (this.state.checkedDarkmode != nextState.checkedDarkmode) {
            return true;
        }
        if (this.props.NotificationsDropDown != nextProps.NotificationsDropDown) {
            return true;
        }
        if (this.props.roledataId != nextProps.roledataId) {
            arraylocalstorage = [];
            return true
        }
        if (this.props.taskIdState != nextProps.taskIdState) {
            return true;
        }
        if (this.props.NotificationsCount != nextProps.NotificationsCount) {
            return true;
        }
        return false;
    }

    //TM(Thanasis Mourselas): componentDidMount() is invoked immediately after a component is mounted
    componentDidMount() {

        this.props.actionTaskContextExpandCollapse(true)
        var widthResolution = window.innerWidth
        if (widthResolution > 1921) {
            document.getElementById('myDropdownNotification').style.width = '80%';
        }

        if (widthResolution === 1536) {
            document.getElementById('myDropdownNotification').style.width = '73%';
        }
        if (widthResolution === 1680) {
            document.getElementById('myDropdownNotification').style.width = '75%';
        }
        if (widthResolution === 1600) {
            document.getElementById('myDropdownNotification').style.width = '73%';
        }
        if (widthResolution === 1440) {
            document.getElementById('myDropdownNotification').style.width = '71%';

        }
        if (widthResolution === 1776) {
            document.getElementById('myDropdownNotification').style.width = '76%';
        }
        document.getElementById('openUnread').style.visibility = 'hidden';
        document.getElementById('openRead').style.visibility = 'hidden';
        document.getElementById('blueTitleUn').style.visibility = 'hidden';
        document.getElementById('blueTitleR').style.visibility = 'hidden';
        document.getElementById('Read').style.marginTop = '2px';
        document.addEventListener('click', this.handleClickOutsideNotification, true);
        document.addEventListener('click', this.handleClickOutsideHistoryTasks, true);
        FetchData('/api/version')
            .then(response => {
                apiVersion = response.data.apiVersion
            })
            .catch(error => {
                if (error == "TOKEN_REFRESH_EXCEPTION") {
                    alert('Your login session has expired, please log in again.')
                    window.location.href = '/';
                }
            })
    }

    //TM(Thanasis Mourselas): componentWillUnmount() is invoked immediately before a component is unmounted and destroyed
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutsideNotification, true);
        document.removeEventListener('click', this.handleClickOutsideHistoryTasks, true);
    }

    //TM(Thanasis Mourselas): is invoked immediately after updating occurs.

    componentDidUpdate(prevProps) {
        var widthResolution = window.innerWidth
        if (this.props.roledataId != prevProps.roledataId) {
            arraylocalstorage = [];
        }
        if (this.props.taskcontextExpandCollapse === false) {

            if (widthResolution > 1921) {
                document.getElementById('myDropdownNotification').style.width = '95%';
            }
            if (widthResolution === 1680) {
                document.getElementById('myDropdownNotification').style.width = '93%';
            }
            if (widthResolution === 1600) {
                document.getElementById('myDropdownNotification').style.width = '92%';
            }
            if (widthResolution === 1440) {
                document.getElementById('myDropdownNotification').style.width = '92%';
            }
            if (widthResolution === 1920) {
                document.getElementById('myDropdownNotification').style.width = '94%';
            }
        }
        if (this.props.taskcontextExpandCollapse === true) {
            if (widthResolution > 1921) {
                document.getElementById('myDropdownNotification').style.width = '80%';
            } else if (widthResolution > 1536 && widthResolution < 1681) {
                document.getElementById('myDropdownNotification').style.width = '73%';
            }
            else if (widthResolution > 1681 && widthResolution < 1709) {
                document.getElementById('myDropdownNotification').style.width = '75%';
            } else if (widthResolution === 1600) {
                document.getElementById('myDropdownNotification').style.width = '73%';
            } else if (widthResolution > 1439 && widthResolution < 1537) {
                document.getElementById('myDropdownNotification').style.width = '71%';
            } else if (widthResolution > 1709 && widthResolution < 1778) {
                document.getElementById('myDropdownNotification').style.width = '76%';
            } else if (widthResolution === 1920) {
                document.getElementById('myDropdownNotification').style.width = '81%';
            }
            else {
                document.getElementById('myDropdownNotification').style.width = '94';
            }
        }
        if (this.props.taskIdState != prevProps.taskIdState) {
            if (arraylocalstorage.length > 9) {
                arraylocalstorage.shift()
            } else {
                if (this.props.taskNameState !== null && this.props.taskNameState !== undefined) {
                    var taskName = this.props.taskNameState.replace("<b style=margin-right:69px>", "").replace("</b>", "")
                    arraylocalstorage.push({ taskid: this.props.taskIdState, taskname: this.props.taskNameState, taskName: taskName, taskCount: this.props.taskNotifications })
                    arraylocalstorage = Object.values(arraylocalstorage.reduce((acc, cur) => Object.assign(acc, { [cur.taskid]: cur }), {}))
                }
            }
        }
    }


    //TM(Thanasis Mourselas): TaskHistory DropDown UI
    dropdown = (event) => {

        document.getElementById("myDropdown").classList.toggle("show");
    }

    //TM(Thanasis Mourselas): Notification DropDown UI
    dropdownNotification = (event) => {


        document.getElementById("myDropdownNotification").classList.toggle("show");

    }

    //TM(Thanasis Mourselas): Settings DropDown UI
   
    handleClickOutsideHistoryTasks = event => {
        document.getElementById("myDropdown").classList.remove("show");

    }

    ExitClick = () => {
        this.props.setState(undefined)
        this.props.history.push("-2");
    }

    //TM(Thanasis Mourselas): task history event click forward
    handleClickforward = () => {
        var idx = arraylocalstorage.findIndex(t => t.taskid === this.props.taskIdState)
        if (arraylocalstorage[idx + 1] != undefined) {
            this.onclicktask(arraylocalstorage[idx + 1].taskid + ',' + arraylocalstorage[idx + 1].taskname)
        }
        this.props.actionTabsSet(undefined)
    }

    //TM(Thanasis Mourselas): task history event click backward
    handleClickbackward = () => {
        var idx = arraylocalstorage.findIndex(t => t.taskid === this.props.taskIdState)
        if (arraylocalstorage[idx - 1] != undefined) {
            this.onclicktask(arraylocalstorage[idx - 1].taskid + ',' + arraylocalstorage[idx - 1].taskname)
        }
        this.props.actionTabsSet(undefined)
    }

    onclicktask = (id) => {
        var splitId = id.split(',')
        this.props.taskIdSet(splitId[0])
        this.props.taskNameSet(splitId[1])
        this.props.actionTabsSet(undefined)
        document.getElementById("myDropdown").classList.remove("show");
    }
    //TM(Thanasis Mourselas): LOGOUT EVENT
    handleClick = () => {
        FetchData('/api/WRU/Logout/' + this.props.UserId)
        localStorage.clear();
        window.location.href = '/';
    }
    //changedirectory = (id) => {
    gotoObject = (e1) => {

        this.props.setCurrentObject(e1)
    }
    openReadnotifications = (e) => {
        // console.log('openread')
        document.getElementById('openRead').style.visibility = 'visible';
        document.getElementById('openUnread').style.visibility = 'hidden';
        // document.getElementById('blueTitleUn').style.visibility = 'hidden';
        document.getElementById('redTitleR').style.visibility = 'hidden';
        document.getElementById('blueTitleR').style.visibility = 'visible';
        document.getElementById('blueTitleR').style.height = '600px';
        document.getElementById('Read').style.marginTop = '2px';
        document.getElementById('blueTitleUn').style.visibility = 'hidden';
        document.getElementById('redTitleUn').style.visibility = 'visible';
        document.getElementById('openUnread').style.visibility = 'hidden';
        document.getElementById('blueTitleUn').style.visibility = 'hidden';
        document.getElementById('redTitleUn').style.visibility = 'visible';

    }
    closeReadnotifications = (e) => {
        // console.log('closeread')
        document.getElementById('openRead').style.visibility = 'hidden';
        document.getElementById('blueTitleR').style.visibility = 'hidden';
        document.getElementById('redTitleR').style.visibility = 'visible';
    }
    openUnreadnotifications = (e) => {
        // console.log('openunread')
        document.getElementById('openUnread').style.visibility = 'visible';
        document.getElementById('redTitleUn').style.visibility = 'hidden';
        document.getElementById('blueTitleUn').style.visibility = 'visible';

        document.getElementById('openRead').style.visibility = 'hidden';
        document.getElementById('blueTitleR').style.visibility = 'hidden';
        document.getElementById('redTitleR').style.visibility = 'visible';

        var widthResolution = window.innerWidth
        if (widthResolution > 1829 && widthResolution > 1921) {
            document.getElementById('Read').style.marginTop = '740px';
        }

        if (widthResolution > 1829 && widthResolution < 1921) {
            document.getElementById('Read').style.marginTop = '640px';
        }
        if (widthResolution > 1681 && widthResolution < 1777) {
            document.getElementById('Read').style.marginTop = '570px';
        }
        if (widthResolution > 1599 && widthResolution < 1681) {
            document.getElementById('Read').style.marginTop = '600px';
        }
        if (widthResolution > 1440 && widthResolution < 1601) {
            document.getElementById('Read').style.marginTop = '480px';
        }
        if (widthResolution > 1279 && widthResolution < 1441) {
            document.getElementById('Read').style.marginTop = '480px';
        }


    }
    closeUnreadnotifications = (e) => {
        //  console.log('closeunread')
        document.getElementById('openUnread').style.visibility = 'hidden';
        document.getElementById('blueTitleUn').style.visibility = 'hidden';
        document.getElementById('redTitleUn').style.visibility = 'visible';
        document.getElementById('Read').style.marginTop = '2px';
    }
    onValueChanged(e) {
        let optionName = null;
        switch (e.component.option('text')) {
            case 'Show Row Lines': {
                optionName = 'showRowLines';
                break;
            }
            case 'Show Borders': {
                optionName = 'showBorders';
                break;
            }
            case 'Alternating Row Color': {
                optionName = 'rowAlternationEnabled';
                break;
            }
            default: {
                optionName = 'showColumnLines';
                break;
            }
        }
        this.setState({
            [optionName]: e.value
        });
    }

    handleClicksettings() {
        if (!this.state.popupVisible) {
           
            document.addEventListener('click', this.handleOutsideClicksettings, false);
        } else {
           
            document.removeEventListener('click', this.handleOutsideClicksettings, false);
        }

        this.setState(prevState => ({
            popupVisible: !prevState.popupVisible,
        }));
    }

    handleOutsideClicksettings(e) {
        if (this.node.contains(e.target)) {
            return;
        }

        this.handleClicksettings();
    }

    render() {
        var widthResolution = window.innerWidth;
        var heightDatagrid;
        if (widthResolution === 1600) {
            heightDatagrid === '400';
        } else {
            heightDatagrid === '670';
        }
        const { showColumnLines, showRowLines, showBorders, rowAlternationEnabled } = this.state;
        if (this.props.notifications !== undefined) {
            var unread = this.props.notifications.filter(item => item["is New"] === true)
            var read = this.props.notifications.filter(item => item["is New"] === false)
        }


        var li
        var DropDownNotification
        if (this.props.notifications != undefined) {
            DropDownNotification = this.props.notifications.slice(Math.max(this.props.notifications.length - 5, 0))
        }
        var headerStyles;
        if (this.state.checkedDarkmode === false) {
            headerStyles = window.defaultTheme;
        } else {
            headerStyles = window.darkTheme;
        }
        var DropDownNotificationOptions
        if (DropDownNotification !== undefined) {
            DropDownNotificationOptions = DropDownNotification.map((i) => {
                return <li onClick={this.gotoObject.bind(this, i.roleID + "," + i.folderID)} style={{ width: '400', cursor: 'pointer' }}>
                    <a>
                        <i className="fa fa-bell" style={{ color: '#236389' }}></i> &nbsp; {i["required Action"]} &nbsp; {i["item Description"]}
                    </a>
                </li>
            })

        }
        return (
            <React.Fragment>
                <header className="main-header" style={headerStyles.toolbarHeader} >
                    <Logo />
                    <ChangeRole />
                    <nav className="navbar navbar-static-top" >
                        <div className="navbar-custom-menu">
                            <ul className="nav navbar-nav">
                                <li style={{ cursor: 'pointer', borderRightStyle: 'solid', borderRightWidth: '1px', marginLeft: '10px', paddingRight: '24px', width: '156px' }} onClick={this.handleClick}>
                                    <span className="logout" style={{fontFamily: 'Roboto'}}>Logout</span>
                                    <span style={{ width: '40px', marginLeft: '-20px' }}><SvgLogout /></span>
                                </li>
                                <li id="notifications" style={{ cursor: 'pointer', borderRightStyle: 'solid', borderRightWidth: '1px', width: '189px', paddingLeft: '6px' }}>
                                    <span onClick={this.dropdownNotification} className="notifications" style={{ fontFamily: 'Roboto' }}>Notifications</span>
                                    <span style={{ width: '40px', marginLeft: '-20px' }}> <SvgNotifications style={{ marginTop: '0px' }} />
                                        {
                                            this.props.notificationsCount > 0 &&
                                            <span className="badge1" style={{ fontSize: '10px', width: '23px', maxWidth: '46px', height: '23px', paddingTop: '7px', marginTop: '-37px', marginLeft: '-14px' }}>{this.props.notificationsCount}</span>
                                        }
                                    </span>
                                    <ul id="myDropdownNotification" className="notificationdropdown-content" >
                                        <li style={{ marginLeft: '-39px', height: '50px', borderBottom: '1px solid #ddd', boxShadow: '0px 3px 6px #00000029', color: "#1B97E1", fontSize: '16px', marginTop: '-13px', paddingTop: '14px' }}>
                                            <span style={{ marginLeft: '31px' }}>Notifications</span>
                                        </li>
                                        <div id="dx-toolbar-items-container" style={{ width: '100%', border: '0px solid #111' }}>

                                            <li id="Unread" style={{ height: '50px', marginLeft: '-39px', borderLeft: '0px', borderRight: '0px', borderTop: '1px solid #ddd', borderBottom: '1px solid #ddd', paddingTop: '12px' }}>
                                                <span onClick={this.openUnreadnotifications} id="redTitleUn" style={{ color: '#6F7E95', marginLeft: '30px', position: 'fixed' }} > Unread Notifications  <i className="glyphicon glyphicon-menu-right" style={{ marginTop: '-4px', color: '#6F7E95' }}></i> </span>
                                                <span onClick={this.closeUnreadnotifications} id="blueTitleUn" style={{ color: '#01BCD4', marginLeft: '30px', position: 'fixed', top: '147px', zIndex: '10000' }}> Unread Notifications  <i className="glyphicon glyphicon-menu-down" style={{ marginTop: '-4px', color: '#6F7E95' }}></i> </span>
                                                <div id="openUnread"  >
                                                    {
                                                        this.props.notifications !== undefined &&
                                                        <DataGrid
                                                            dataSource={unread}
                                                            keyExpr="id"
                                                            onRowDblClick={this.gotoObject}
                                                            height={heightDatagrid}
                                                            width={'100%'}

                                                            showColumnLines={showColumnLines}
                                                            showRowLines={showRowLines}
                                                            showBorders={showBorders}
                                                            rowAlternationEnabled={rowAlternationEnabled}
                                                            columnAutoWidth={true}
                                                            selection={{ mode: 'single' }}
                                                        >
                                                            <SearchPanel visible={true} />
                                                            <Paging defaultPageSize={15} style={{ marginTop: '-20px' }} />
                                                            <Pager
                                                                showPageSizeSelector={true}
                                                                allowedPageSizes={[15, 40, 100]}
                                                                showInfo={true}
                                                            />
                                                            <ColumnFixing enabled={false} />
                                                            <Column width={'20%'} dataField="item Type" caption="Item Type" />
                                                            <Column width={'20%'} dataField="item Description" caption="Item Description" />
                                                            <Column width={'20%'} dataField="reason for Notification" caption="Reason for Notification" />
                                                            <Column width={'20%'} dataField="required Action" caption="Required Action" />
                                                            <Column width={'20%'} dataField="notification Date/Time" caption="Notification Date/Time" dataType='datetime' />
                                                            <Column style={{ cursor: 'pointer' }} type="buttons" width={110} dataField="Go to">

                                                                <Button icon={myIcon} onClick={this.gotoObject} />
                                                            </Column>

                                                        </DataGrid>
                                                    }

                                                </div>


                                            </li>
                                            <li id="Read" style={{ height: '50px', marginLeft: '-39px', borderLeft: '0px', borderRight: '0px', borderTop: '1px solid #ddd', borderBottom: '1px solid #ddd', paddingTop: '12px' }}>
                                                <span onClick={this.openReadnotifications} id="redTitleR" style={{ color: '#6F7E95', marginLeft: '30px', position: 'fixed' }} >Read Notifications<i className="glyphicon glyphicon-menu-right" style={{ marginTop: '-4px', marginLeft: '16px', color: '#6F7E95' }}></i></span>
                                                <span onClick={this.closeReadnotifications} id="blueTitleR" style={{ color: '#01BCD4', marginLeft: '30px', position: 'fixed', top: '197px', zIndex: '10000' }}>Read Notifications<i className="glyphicon glyphicon-menu-down" style={{ marginTop: '-4px', marginLeft: '16px', color: '#6F7E95' }}></i></span>
                                                <div id="openRead">
                                                    {
                                                        this.props.notifications !== undefined &&
                                                        <DataGrid
                                                            height={heightDatagrid}
                                                            width={'100%'}
                                                            dataSource={read}
                                                            selection={{ mode: 'single' }}
                                                            showBorders={true}
                                                            hoverStateEnabled={true}
                                                            keyExpr="id"
                                                            onRowDblClick={this.gotoObject}
                                                            showColumnLines={showColumnLines}
                                                            showRowLines={showRowLines}
                                                            showBorders={showBorders}
                                                            rowAlternationEnabled={rowAlternationEnabled}
                                                        >
                                                            <Paging defaultPageSize={14} />
                                                            <Pager
                                                                showPageSizeSelector={true}
                                                                allowedPageSizes={[15, 40, 100]}
                                                                showInfo={true} />
                                                            <SearchPanel visible={true} />
                                                            <Column width={100} dataField="item Type" caption="Item Type" />
                                                            <Column dataField="item Description" caption="Item Description" />
                                                            <Column dataField="reason for Notification" caption="Reason for Notification" />
                                                            <Column dataField="required Action" caption="Required Action" />
                                                            <Column dataField="notification Date/Time" caption="Notification Date/Time" dataType='datetime' />
                                                            <Column type="buttons" width={110} dataField="Go to">

                                                                <Button icon={myIcon} onClick={this.gotoObject} />
                                                            </Column>
                                                        </DataGrid>
                                                    }

                                                </div>

                                            </li>


                                        </div>
                                    </ul>
                                </li>
                                <span style={{ width: '34px', padding: '5px', marginLeft: '19px', marginTop: '-2px' }}>
                                    <a style={{ cursor: 'pointer' }} onClick={this.handleClickbackward}><SvgLeftarrow /></a>
                                </span>
                                <li style={{ borderRightStyle: 'solid', borderRightWidth: '0px', marginTop: '-15px', paddingRight: '19px', marginLeft: '28px',paddingLeft: '8px' }} className="dropdown user user-menu notifications-menu">

                                    <a onClick={this.dropdown} className="taskdropbtn" style={{ color: '#284672' }} >
                                        Latest Tasks
                                    </a>
                                    <ul id="myDropdown" className="taskdropdown-content" >
                                        {li}
                                        <li>
                                            <ul className="menu inner-content-div">
                                                {
                                                    arraylocalstorage.map((task) => {
                                                        if (task.taskCount > 0) {
                                                            return <li className="litaskhistory" >
                                                                <a style={{ height: '47px', paddingTop: '7px', width: '352px', fontFamily:'Roboto Condensed' }} onClick={this.onclicktask.bind(this, task.taskid + "," + task.taskname)}>
                                                                    <i className="icon expand-icon icon-ArrowContext" style={{ color: '#236389' }}></i> &nbsp; {task.taskName}&nbsp;<span className="badgeHeader badge-notify">{task.taskCount}</span>
                                                                </a>
                                                            </li>
                                                        } else {
                                                            return <li className="litaskhistory" >
                                                                <a style={{ height: '47px', paddingTop: '7px', width: '352px', fontFamily: 'Roboto Condensed' }} onClick={this.onclicktask.bind(this, task.taskid + "," + task.taskname)}>
                                                                    <i className="icon expand-icon icon-ArrowContext" style={{ color: '#236389' }}></i> &nbsp; {task.taskName}
                                                                </a>
                                                            </li>
                                                        }
                                                    })
                                                }
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <span style={{ width: '12px', padding: '5px', marginTop: '-2px' }}>
                                    <a style={{ cursor: 'pointer' }} onClick={this.handleClickforward}><SvgRightarrow /></a>
                                </span>
                                <span style={{ width: '30px', padding: '10px', height: '30px', borderRight: '1px solid #707070' }}></span>
                                <li className="popover-container" ref={node => { this.node = node; }} >
                                    <a onClick={this.handleClicksettings} className="dropSettings" style={{ marginTop: '-14px', marginLeft: '-29px' }} ><span style={{ fontFamily: 'Roboto' }} className="settings">
                                        Settings
                                    </span>
                                        <span style={{ width: '40px', marginLeft: '-20px' }}>   <SvgSettings /></span>
                                    </a>
                                    {this.state.popupVisible && (
                                        <ul id="myDropdownSettings" className="dropdown-content-settings" >
                                            <li>
                                                <ul className="menu inner-content-div" style={{ fontFamily: 'Roboto Condensed' }}>
                                                    <li style={{ height: '60px', borderBottom: '1px  solid #ccc', paddingTop: '11px', marginLeft: '-80px' }}>
                                                        <span className="Caching">Enable/Disable Context Caching</span>
                                                        <span style={{ marginTop: '5px', float: 'right', marginRight: '77px' }} ><Switch
                                                            style={{ height: '22px' }}
                                                            className="react-switch"
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}

                                                            checked={this.state.checked}
                                                            onChange={this.handleChange}
                                                        />&nbsp;&nbsp;Caching is <b style={{ color: this.state.checked ? '#06BDA7' : 'red' }}>{this.state.checked ? 'on' : 'off'}</b></span>


                                                        {/*<p className="Caching">Context Caching is <b style={{ color: this.state.checked ? 'green' : 'red' }}>{this.state.checked ? 'on' : 'off'}</b>.</p>*/}
                                                    </li>

                                                    {/*<li className="Caching">Enable/Disable Dark Mode </li>
                                                        <Switch
                                                            className="react-switch"
                                                            checked={this.state.checkedDarkmode}
                                                            onChange={this.handleChangeDarkmode}
                                                        />
                                                    <p className="Caching">Dark Mode is <b style={{ color: this.state.checkedDarkmode ? 'green' : 'red' }}>{this.state.checkedDarkmode ? 'on' : 'off'}</b>.</p>
                                                    </li>*/}
                                                    <li>
                                                        <p className="InfoVersionWeb">Web client version: web.10.05</p>
                                                        <p className="InfoVersionApi">API version: {apiVersion}</p>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    )}
                                </li>
                            </ul>
                        </div>
                    </nav>
                </header>
            </React.Fragment>
        )
    }
    gotoObject = e => {
        //var modal
      
        this.props.setCurrentObject(e.row.data)
        document.getElementById("myDropdownNotification").classList.remove("show");

    }
}
const mapStateToProps = state => {
    return {
        roledataId: state.roleDataId,
        taskNameState: state.taskDataName,
        taskIdState: state.taskDataId,
        themeState: state.currentThemeName,
        notificationsCount: state.currNotificationsCount,
        notifications: state.currNotifications,
        taskNotifications: state.currTaskNotificationState,
        taskcontextExpandCollapse: state.currTaskContextExpandCollapse,
        cacheState: state.currCacheState,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        taskNameSet: payload => dispatch(setTaskNameAction(payload)),
        taskIdSet: payload => dispatch(setTaskIdAction(payload)),
        setState: payload => dispatch(setStateAction(payload)),
        currObjectSet: payload => dispatch(setCurrentObjectId(payload)),
        currThemeSet: payload => dispatch(setCurrentThemeAction(payload)),
        currFooterSet: payload => dispatch(setCurrentFooterAction(payload)),
        actionTaskContextExpandCollapse: payload => dispatch(setActionTaskContextExpColaps(payload)),
        actionTabsSet: payload => dispatch(setActionTabs(payload)),

    };
};
export default connect(mapStateToProps, mapDispatchToProps)(HeaderNavbar);



// WEBPACK FOOTER //
// ./src/components/TaskView/Toolbar/Header.js